// extracted by mini-css-extract-plugin
export var container = "_36-0";